import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AddWalletComponent } from '../add-wallet/add-wallet.component';
import { AngularMaterialModule } from 'src/app/material.module';
@Component({
    selector: 'app-change-wallet',
    templateUrl: './change-wallet.component.html',
    imports: [AngularMaterialModule],
    standalone: true,
    styleUrls: ['./change-wallet.component.scss'],
})
export class ChangeWalletComponent implements OnInit {
    wallets: any = [];
    constructor(
      public dialogRef: MatDialogRef<ChangeWalletComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { wallets: any },
      private readonly dialog: MatDialog
    ) {}

    ngOnInit() {
      this.wallets = this.data.wallets;
    }

    switchToAddNewWallet() {
        this.dialogRef.close();

        const dialog = this.dialog.open(AddWalletComponent, {
            width: '450px',
            height: '100%',
            position: { right: '0px', top: '0px' },
            panelClass: 'dialog-side-panel',
            autoFocus: false,
            data: {
              wallets: this.wallets
            },
        });
    }

    changeSelectedWallet(wallet: any) {
        this.wallets.forEach((wallet: any) => {
            wallet.selected = false;
        });

        wallet.selected = true;
        this.dialogRef.close(wallet);
    }
}
